import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import CourtBlockTypeEdit   from "./CourtBlockTypeEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";
import ColorCircle          from "Dashboard/Components/Common/ColorCircle";



/**
 * The Court Block Type List
 * @returns {React.ReactElement}
 */
function CourtBlockTypeList() {
    const { fetch, load } = useList("courtBlockType");

    const data = Store.useState("courtBlockType");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("courtBlockType");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "courtBlockTypeID", elemID, "name");

    return <Main>
        <Header message="COURT_BLOCK_TYPES_NAME" icon="block-type">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="COURT_BLOCK_TYPES_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="name"     message="GENERAL_NAME"     isTitle isFlex smallSpace bigMobile />
                    <TableHeader field="priority" message="GENERAL_PRIORITY" isFlex maxWidth="80" align="center" />
                    <TableHeader field="status"   message="GENERAL_STATUS"   isFlex maxWidth="100" align="center" />
                    <TableHeader field="position" message="GENERAL_POSITION" isFlex maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.courtBlockTypeID} elemID={elem.courtBlockTypeID}>
                        <TableCell>
                            <ColorCircle color={elem.color} />
                            {elem.name}
                        </TableCell>
                        <TableCell message={elem.priority}   />
                        <TableCell message={elem.statusName} textColor={elem.statusColor} />
                        <TableCell message={elem.position}   />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="COURT_BLOCK_TYPES_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="COURT_BLOCK_TYPES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <CourtBlockTypeEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="COURT_BLOCK_TYPES_DELETE_TITLE"
            message="COURT_BLOCK_TYPES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default CourtBlockTypeList;
